// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_gop","delete":"styles_delete__3t3E-","update":"styles_update__w5nZP","add":"styles_add__1a9hL"};